export const STATE_ENUM = {
    active: "active",
    pending: "pending",
    disabled: "disabled",
};
